import { Controller } from "@hotwired/stimulus"

// Выбор варианта открытки на экране результата (web-08): клик по варианту
// выделяет его (is-selected), снимая выделение с остальных — визуальное
// сравнение и фокус на понравившемся перед скачиванием/покупкой (web-09).
export default class extends Controller {
  static targets = ["variant"]

  choose(event) {
    const chosen = event.currentTarget
    this.variantTargets.forEach((v) => v.classList.toggle("is-selected", v === chosen))
  }
}
